module.exports = {
  drawerWidth: 240,
}
